/**
 * @generated SignedSource<<07395717ab7ecc60c76f61afb13706a9>>
 * @relayHash 029e76bfcd70279acd22d488125dc454
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 936914f8502bab28553df0f472fa4f87cbb23cb871cb9a825222f522face951d

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type NotificationAction = "DONT_NOTIFY" | "NOTIFY" | "%future added value";
export type Operation = "ASSIGNED" | "COMPLETE" | "DELETED" | "IN_COMPLETE" | "REWORDED" | "UNASSIGNED" | "%future added value";
export type IndividualInlineTaskNotificationInput = {
  notificationAction?: NotificationAction | null | undefined;
  operation: Operation;
  recipientAccountId: string;
  recipientMentionLocalId?: string | null | undefined;
  taskId: string;
};
export type useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation$variables = {
  contentId: string;
  tasks: ReadonlyArray<IndividualInlineTaskNotificationInput | null | undefined>;
};
export type useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation$data = {
  readonly createInlineTaskNotification: {
    readonly contentId: string;
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation = {
  response: useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation$data;
  variables: useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tasks"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "tasks",
            "variableName": "tasks"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "CreateInlineTaskNotificationPayload",
    "kind": "LinkedField",
    "name": "createInlineTaskNotification",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      },
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "029e76bfcd70279acd22d488125dc454",
    "id": "936914f8502bab28553df0f472fa4f87cbb23cb871cb9a825222f522face951d",
    "metadata": {},
    "name": "useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation($contentId:ID!,$tasks:[IndividualInlineTaskNotificationInput]!){createInlineTaskNotification(input:{contentId:$contentId,tasks:$tasks}){contentId,success,errors{message}}}"
  }
};
})();

(node as any).hash = "fca74fc99391b016271338a6b81b557d";

export default node;
